import { UnifiedTokenData } from 'types/analytics'

const normalizeSearchValue = (value?: string): string => (value ?? '').toLowerCase().replace(/\u20ae/g, 't')

export const tokenMatchesQuery = (token: UnifiedTokenData, query: string): boolean => {
  const trimmed = query.trim()
  if (trimmed.length === 0) return true

  const normalizedQuery = normalizeSearchValue(trimmed)

  if (normalizedQuery.startsWith('0x')) {
    return token.address.toLowerCase().includes(normalizedQuery)
  }

  return (
    normalizeSearchValue(token.symbol).includes(normalizedQuery) ||
    normalizeSearchValue(token.name).includes(normalizedQuery)
  )
}
